import { render } from "./Remerciment.vue?vue&type=template&id=4068d7c0&scoped=true&ts=true"
import script from "./Remerciment.vue?vue&type=script&lang=ts"
export * from "./Remerciment.vue?vue&type=script&lang=ts"

import "./Remerciment.vue?vue&type=style&index=0&id=4068d7c0&lang=scss&scoped=true"

import exportComponent from "E:\\User\\Documents\\GitHub\\PortailMalecites\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4068d7c0"]])

export default __exports__